import script from "./CustomizedContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomizedContent.vue?vue&type=script&lang=ts&setup=true"

import "./CustomizedContent.vue?vue&type=style&index=0&id=2a488d3b&lang=css"

const __exports__ = script;

export default __exports__